import React, { createContext, useContext } from 'react';
import { useAppSelector } from '../redux/hooks';
import { useAgentChat } from '../hooks/useAgentChat';
import type { AgentMessage } from '../types/agent';

interface AgentChatContextValue {
  messages: AgentMessage[];
  sendMessage: (text: string) => void;
  isStreaming: boolean;
  stopStreaming: () => void;
  clearMessages: () => void;
}

const AgentChatContext = createContext<AgentChatContextValue | null>(null);

export const AgentChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const currentSite = useAppSelector((state) => state.site.currentSite);
  const siteId = currentSite?.site_id || null;
  const chat = useAgentChat(siteId);

  return (
    <AgentChatContext.Provider value={chat}>
      {children}
    </AgentChatContext.Provider>
  );
};

export function useSharedAgentChat(): AgentChatContextValue {
  const ctx = useContext(AgentChatContext);
  if (!ctx) {
    throw new Error('useSharedAgentChat must be used within AgentChatProvider');
  }
  return ctx;
}
